<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>

<script>
import store from 'store';
import router from 'router';
import VueI18n from 'services/i18n';
import notifications from 'services/Notifications';

export default {
  beforeRouteEnter(to, from, next) {
    loadApp(to.params.appId).then(next);
  },
  beforeRouteUpdate(to, from, next) {
    loadApp(to.params.appId).then(next);
  },
};

function loadApp(appId) {
  return store.dispatch('application/loadApp', appId).catch(err => {
    console.log('Failed to load application', appId);

    const app = store.getters['application/getApp'](appId);
    const message = app
      ? VueI18n.t('errors.unable_to_load_app', { app_name: app.name })
      : VueI18n.t('errors.unknown_app');

    notifications.add(message, VueI18n.t('notifications.types.warning'));
    router.push({ name: 'home' });
  });
}
</script>

<style lang="scss">
.board:not(.home-board) {
  .card.has-controls {
    .card-header-right {
      position: absolute;
      top: 8px;
      right: 10px;
    }
  }
}

.card.is-padded > .card-content {
  padding: 1rem;
}

.home-board .card.is-padded > .card-content {
  padding: 1.5rem;
}
</style>
